import { NOTIFICATION_TYPES } from "constants/v2/notifications";
import { createSelector } from "reselect";

import { notificationsEntityAdapter, notificationsSlice } from "./slice";

const selectNotificationsState = (state) => state[notificationsSlice.name];

export const selectNotificationsIds = createSelector(selectNotificationsState, (notificationsState) =>
  notificationsEntityAdapter.getSelectors().selectIds(notificationsState),
);

export const selectNotificationsEntites = createSelector(selectNotificationsState, (notificationsState) =>
  notificationsEntityAdapter.getSelectors().selectEntities(notificationsState),
);

export const selectAllNotifications = createSelector(
  selectNotificationsIds,
  selectNotificationsEntites,
  (ids, entities) => ids.map((id) => entities[id]).filter(Boolean),
);

export const selectTotalNotifications = createSelector(
  selectNotificationsState,
  (notificationsState) => notificationsState.count,
);

export const selectCompletedNotificationIds = createSelector(
  selectNotificationsIds,
  selectNotificationsEntites,
  (ids, entities) =>
    ids.filter((id) => entities[id].status === "completed" && entities[id].type !== NOTIFICATION_TYPES.DYNAMICFLIP),
);

export const selectInProgressNotificationIds = createSelector(
  selectNotificationsIds,
  selectNotificationsEntites,
  (ids, entities) =>
    ids.filter((id) => entities[id].status === "inProgress" && entities[id].type !== NOTIFICATION_TYPES.DYNAMICFLIP),
);

export const selectFailedNotificationIds = createSelector(
  selectNotificationsIds,
  selectNotificationsEntites,
  (ids, entities) =>
    ids.filter((id) => entities[id].status === "failed" && entities[id].type !== NOTIFICATION_TYPES.DYNAMICFLIP),
);

export const selectCancelledNotificationIds = createSelector(
  selectNotificationsIds,
  selectNotificationsEntites,
  (ids, entities) =>
    ids.filter((id) => entities[id].status === "cancelled" && entities[id].type !== NOTIFICATION_TYPES.DYNAMICFLIP),
);

export const selectNotificationDetailsById = createSelector(
  selectNotificationsState,
  (state, props) => ({
    notificationId: props.notificationId,
    notificationData: props.notificationData,
  }),
  (state, { notificationId, notificationData }) => {
    if (notificationData) {
      return notificationData;
    }

    return notificationsEntityAdapter.getSelectors().selectById(state, notificationId) || null;
  },
);

export const selectNotificationTypeById = createSelector(
  selectNotificationDetailsById,
  (notificationDetails) => notificationDetails?.type || null,
);

export const selectNotificationImageById = createSelector(
  selectNotificationDetailsById,
  (notificationDetails) => notificationDetails?.metadata?.clipThumbnail || null,
);

export const selectNotificationProgressById = createSelector(
  selectNotificationDetailsById,
  (notificationDetails) => notificationDetails?.progress || 0,
);

export const selectNotificationCreatedAtById = createSelector(
  selectNotificationDetailsById,
  (notificationDetails) => notificationDetails?.createdAt || null,
);

export const selectNotificationClipNameById = createSelector(
  selectNotificationDetailsById,
  (notificationDetails) =>
    notificationDetails?.metadata?.highlightName || notificationDetails?.metadata?.clipName || null,
);

export const selectNotificationStreamNameById = createSelector(
  selectNotificationDetailsById,
  (notificationDetails) => notificationDetails?.metadata?.streamName || null,
);

export const selectNotificationStatusById = createSelector(
  selectNotificationDetailsById,
  (notificationDetails) => notificationDetails?.status || null,
);

export const selectNotificationPageUrlById = createSelector(
  selectNotificationDetailsById,
  (notificationDetails) => notificationDetails?.metadata?.pageUrl || null,
);

export const selectNotificationExportTypeById = createSelector(
  selectNotificationDetailsById,
  (notificationDetails) => notificationDetails?.metadata?.exportType || null,
);

export const selectNotificationAspectRatioById = createSelector(
  selectNotificationDetailsById,
  (notificationDetails) => notificationDetails?.metadata?.aspectRatio || null,
);
